module.exports = __webpack_public_path__ + "static/media/DSCF3811.53cc3b6c.jpg";